import { Icon, Typography } from "@/components/atoms";

interface TripVehicleRowProps {
  /** Top line — the transfer type's label (e.g. "Airport Transfer"), or a fallback when none is chosen. */
  transferLabel: string;
  /** Vehicle + capacity, e.g. "Executive Sedan (1 Pax & 1 Bag)". */
  vehicleType?: string;
  /** Formatted duration (e.g. "2 hours") for hourly/daily rates — rendered as "Duration: …". */
  duration?: string;
  /** Comma-separated extras names. */
  extras?: string;
}

/**
 * The vehicle block of the Trip Details box: the Car icon over up to four stacked lines (transfer type,
 * vehicle + capacity, duration, extras). Presentational only — takes plain strings so the
 * SAME layout renders in both the live Booking Summary (`TripCoreRows`, mapped from the draft) and the
 * post-submit confirmation (`TripDetailsCard`, mapped from its serialisable snapshot). Keeping it in one
 * place is what stops the two from drifting (a new line like duration lands in both at once).
 */
export const TripVehicleRow = ({ transferLabel, vehicleType, duration, extras }: TripVehicleRowProps) => (
  <div className="flex items-start gap-2.5">
    <Icon name="Car" size="md" className="shrink-0 text-neutral-dark-gray" />
    <div className="flex min-w-0 flex-col gap-0.5">
      <Typography variant="small" className="block">
        {transferLabel}
      </Typography>
      {vehicleType && (
        <Typography variant="small-regular" className="block text-neutral-dark-gray">
          {vehicleType}
        </Typography>
      )}
      {duration && (
        <Typography variant="small-regular" className="block text-neutral-dark-gray">
          Duration: {duration}
        </Typography>
      )}
      {extras && (
        <Typography variant="small-regular" className="block text-neutral-dark-gray">
          {extras}
        </Typography>
      )}
    </div>
  </div>
);
